import { ReactNode } from "react";
import { Box, Paper, SxProps, Theme } from "@mui/material";
import { AllSelectHeader } from "./AllSelectHeader";

interface PaperSlotProps {
  hasAllSelect?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  allSelected?: boolean;
  onAllSelect?: (currentAllSelected: boolean) => void;
  sx?: SxProps<Theme>;
}

export default function PaperSlot({
  hasAllSelect,
  header,
  footer,
  children,
  allSelected,
  onAllSelect,
  sx,
}: PaperSlotProps) {
  return (
    <Paper
      sx={{ ...paper, ...sx }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {hasAllSelect ? (
        <Box sx={head} onMouseDown={(e) => e.preventDefault()}>
          <AllSelectHeader
            allSelected={allSelected}
            onAllSelect={onAllSelect}
          />
        </Box>
      ) : (
        header
      )}
      {children}
      {footer && (
        <Box sx={foot} onMouseDown={(e) => e.preventDefault()}>
          {footer}
        </Box>
      )}
    </Paper>
  );
}

const paper = {
  boxShadow:
    "0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)",
};

const head = {
  borderBottom: "1px solid #e0e0e0",
  padding: "4px",
  backgroundColor: "#fff",
} as const;

const foot = {
  borderTop: "1px solid #e0e0e0",
  padding: "8px",
  backgroundColor: "#fff",
} as const;
